// extracted by mini-css-extract-plugin
export default {"contents":"DD-z","sectionHeading":"ED-z"};